export default __webpack_public_path__ + "static/media/empty-events.641777c0.svg";